import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from '@node-space/ui-components'
import { ExternalLinks } from 'constants/links'

export const DakotaFooter = () => {
  const { t } = useTranslation()

  const licenseHelpUrl = ExternalLinks.LICENSES_HELP_URL ?? ''

  const LicenseHelpLink = useMemo(() => {
    if (!licenseHelpUrl) return null
    return (
      <>
        {t('customerPendingAgreements.variations.dakota.forMoreInformation')}
        <Link href={licenseHelpUrl} target="_blank">
          {t('customerPendingAgreements.footerLink')}
        </Link>
        .
      </>
    )
  }, [licenseHelpUrl])

  return (
    <>
      {t('customerPendingAgreements.variations.dakota.footer')}
      {LicenseHelpLink}
    </>
  )
}
